import {
  Box,
  Button,
  HStack,
  Icon,
  IconButton,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import { RiShoppingCart2Line } from "@remixicon/react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import useScreenWidth from "../lib/useScreenWidth";
import { useCartStore } from "../store/useCartStore";
import { useGetUserLoginStore } from "../store/useGetUserLoginStore";
import { useDarkWhiteColor } from "../themes/colors";
import NavigationDrawer from "./NavigationDrawer";
import ButtonLogin from "./button/ButtonLogin";
import { PopoverHeaderNotification } from "./header/PopoverHeaderNotification";
import { PopoverHeaderSearch } from "./header/PopoverHeaderSearch";
import { PopoverHeaderSwitchAccount } from "./header/PopoverHeaderSwitchAccount";
import { DesktopNav } from "./menu/DesktopNav";

export const Header = () => {
  const navigate = useNavigate();
  const bgBnw = useDarkWhiteColor();
  const sw = useScreenWidth();

  const { totalProductsInCart, initializeCart } = useCartStore();

  const { currentActiveUser, getCurrentActiveUser, getLoggedUsers } =
    useGetUserLoginStore();

  useEffect(() => {
    getLoggedUsers();
  }, [getLoggedUsers]);

  useEffect(() => {
    getCurrentActiveUser();
  }, [getCurrentActiveUser]);

  useEffect(() => {
    initializeCart();
  }, [initializeCart]);

  const goToCart = () => {
    navigate("/cart");
  };

  return (
    <Box
      className="root-headers"
      as="header"
      position={"sticky"}
      top={0}
      zIndex={999}
      w={"100%"}
      bg={bgBnw}
    >
      <HStack
        display={"flex"}
        minH={"60px"}
        w={"100%"}
        px={{
          base: "20px",
          sm: "24px",
          md: "32px",
          lg: "40px",
          xl: "48px",
          "2xl": 4,
        }}
        py={{ base: 2 }}
        alignItems={"center"}
        mx={"auto"}
        gap={"28px"}
        justifyContent={"space-between"}
      >
        {sw > 768 && (
          <>
            <HStack as={Link} to="/">
              <Image
                src={logo}
                w={"30px"}
                h={"30px"}
                objectFit={"contain"}
                alt="logo"
              />
              <Text
                textStyle={"h-title"}
                textAlign={{ base: "center", md: "left" }}
                fontFamily={"heading"}
              >
                Bisnis Link
              </Text>
            </HStack>

            <DesktopNav />
          </>
        )}

        <PopoverHeaderSearch />

        <HStack>
          {currentActiveUser && Object.keys(currentActiveUser)?.length > 0 && (
            <HStack alignItems={"center"} gap={"16px"}>
              {currentActiveUser?.role === "buyer" ? (
                totalProductsInCart === 0 ? (
                  <IconButton
                    onClick={goToCart}
                    icon={<Icon as={RiShoppingCart2Line} fontSize={"2xl"} />}
                    variant={"ghost"}
                    size={"md"}
                    aria-label={"Toggle Navigation"}
                  />
                ) : (
                  <HStack as={Link} to="/cart">
                    <Icon as={RiShoppingCart2Line} fontSize={"2xl"} />

                    <Stack
                      bg={"secondary"}
                      rounded={"full"}
                      mt={"-20px"}
                      ml={"-20px"}
                      h={"18px"}
                      w={"18px"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      zIndex={10}
                    >
                      <Text
                        color={"white"}
                        fontWeight={"bold"}
                        fontSize={"8px"}
                      >
                        {totalProductsInCart}
                      </Text>
                    </Stack>
                  </HStack>
                )
              ) : undefined}

              {(currentActiveUser?.role === "buyer" ||
                currentActiveUser?.role === "reseller" ||
                currentActiveUser?.role === "supplier") && (
                <PopoverHeaderNotification />
              )}
            </HStack>
          )}

          <NavigationDrawer />
        </HStack>

        {!currentActiveUser && (
          <HStack gap={"10px"} display={{ base: "none", lg: "flex" }}>
            <ButtonLogin variant="outline" />

            <Button
              as={Link}
              to={"/register"}
              variant={"solid-sm-secondary"}
              px={"20px"}
            >
              Daftar
            </Button>
          </HStack>
        )}

        {sw > 992 &&
          currentActiveUser &&
          Object.keys(currentActiveUser)?.length > 0 && (
            <PopoverHeaderSwitchAccount />
          )}
      </HStack>
    </Box>
  );
};
